// @flow

// Libs
import React from 'react'

// Components
import SvgIcon from './SvgIcon'
import svg from 'material-design-icons/navigation/svg/production/ic_menu_24px.svg'

// Types
type Props = {
  size?: number,
  color?: string,
  style?: Object,
}

// Exports
export default function Menu({ size = 24, color = 'rgb(255,255,255)', style = {} }: Props): React.Element<any> {
  return <SvgIcon size={size} color={color} src={svg} style={style} />
}
